import { AfterContentInit, Component, EventEmitter, Host, Input, OnDestroy, Output } from '@angular/core';
import { AttributionLike, RasterOperation, RasterOperationType, source } from 'openlayers';

import { LayerImageComponent } from '../layers/layerimage.component';

@Component({
  selector: 'aol-source-raster',
  template: `<ng-content></ng-content>`
})
export class SourceRasterComponent implements AfterContentInit, OnDestroy {
  instance: source.Raster;

  @Input() operation?: RasterOperation;
  @Input() threads?: number;
  @Input() lib?: object;
  @Input() operationType?: RasterOperationType;

  @Output() beforeOperations: EventEmitter<source.RasterEvent> = new EventEmitter<source.RasterEvent>();
  @Output() afterOperations: EventEmitter<source.RasterEvent> = new EventEmitter<source.RasterEvent>();

  public componentType: string = 'source';

  @Input() attributions: AttributionLike;

  sources: source.Source[] = [];

  constructor(@Host() protected layer: LayerImageComponent) {}

  ngAfterContentInit() {
    this.instance = new source.Raster(this);

    this.instance.on('beforeoperations', (event: source.RasterEvent) => this.beforeOperations.emit(event));
    this.instance.on('afteroperations', (event: source.RasterEvent) => this.afterOperations.emit(event));

    this._register(this.instance);
  }

  ngOnDestroy() {
    if (this.layer) {
      this.layer.instance.setSource(null);
    }

    this.sources = [];
  }

  protected _register(source: source.Source) {
    if (this.layer) {
      this.layer.instance.setSource(source);
    }

    this.sources = [source];
  }
}
